import React from 'react';
import * as _ from 'lodash';

import PropTypes from 'prop-types';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { Information } from '../../components/modals/common/';
import { messageUtility } from '../../utilities/messageUtility';
import { SENT_TYPE } from '../../utilities/constants';
import Tippy from '../../components/ReactTippy';

import Styles from '../../styles/componentStyle/transmission-error-result.scss';
import NotificationUtility from '../../utilities/notificationUtility';
import InOutDashboardApi from '../../services/inOutDashboard/InOutDashboardApi';
import InOutDashboardService from '../../services/inOutDashboard/InOutDashboardService';
import InfinityScrollLoad from '../InfinityScrollLoad';
import { isNullOrUndefined } from '../../utilities/stringUtil';
import { DIALOG_STATUS } from '../../utilities/constants';
import { extractErrorMessage } from '../../utilities/commonUtil';

/**
 * CCUS送信結果のエラー情報を表示
 * */
class TransmissionErrorResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roleId: LocalStorageService.getRoleId(),
      transmissionErrorResults: [],

      isLoading: false, // 取得中フラグ
      isLoaded: false, // データを全て取得したフラグ
      offset: 0,
      limit: 30,
      dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示ステータス
      informationModal: {
        title: null, // モーダルダイアログのタイトル
        message: null, // モーダルダイアログのメッセージ
        buttonText: null, // モーダルダイアログのボタンのタイトル
        multilineText: false, // モーダルダイアログメッセージには複数の行がある場合
      },
    };
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-errormsg-${this.id}`;
  }

  /**
   * CCUS送信結果エラー情報取得API
   */
  loadErrorResults(notify) {
    if (this.isLoaded) {
      notify();
      this.isLoading = true;
      return;
    }
    if (
      isNullOrUndefined(this.props.fieldId) ||
      isNullOrUndefined(this.props.checkInOutLogTransmissionHistoryId)
    ) {
      return;
    }

    this.setState({ isLoading: true });
    const searchParam = this.buildSearchParam();
    InOutDashboardApi.fetchErrorResults(
      this.props.fieldId,
      InOutDashboardService.createSearchErrorResults(searchParam)
    )
      .then(response => {
        if (response.result) {
          const newResults = response.data.entities.transmission_error_result;
          this.setState(prevState => {
            const state = { ...prevState };
            newResults.forEach(item => {
              item['sent_type'] = response.data.entities.sent_type;
              state.transmissionErrorResults.push(item);
            });
            state.offset = state.transmissionErrorResults.length;
            if (newResults.length === 0) {
              state.isLoaded = true;
            }
            return state;
          });
        } else {
          this.showErrorMessageDialog(response);
        }
        if (notify) {
          notify();
        }
      })
      .catch(error => {
        this.showErrorMessageDialog(error);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  buildSearchParam() {
    const searchParam = Object.create(null);
    searchParam.checkInOutLogTransmissionHistoryId = this.props.checkInOutLogTransmissionHistoryId;
    searchParam.offset = this.state.offset;
    searchParam.limit = this.state.limit;
    return searchParam;
  }

  clearErrorResults() {
    this.setState({
      transmissionErrorResults: [],
      isLoaded: false,
      offset: 0,
    });
  }

  componentDidMount() {
    this.loadErrorResults();
  }

  componentDidUpdate(prevProps) {
    const fieldIdChanged = this.props.fieldId !== prevProps.fieldId;
    const historyIdChanged =
      this.props.checkInOutLogTransmissionHistoryId !==
      prevProps.checkInOutLogTransmissionHistoryId;
    if (fieldIdChanged || historyIdChanged) {
      this.clearErrorResults();
      this.loadErrorResults();
    }
  }

  /**
   * CCUS送信結果エラー確認ができるかどうか
   */
  isConfirmAvailable(item) {
    return item.allow_confirm_flag === 1;
  }

  /**
   * CCUS送信結果エラー確認
   */
  async confirmError(item) {
    if (this.state.fieldId !== item.field_id) {
      await NotificationUtility.handleChangeField(item.field_id);
    }

    switch (item.ccus_error_code) {
      case 'DATK0401E':
        window.location.href = `/conference/WorkerConfirm:WorkerInfo,${
          item.worker_id
        }/0/0/0/0`;
        break;
      default:
        window.location.href =
          item.sent_type == SENT_TYPE.checkInOutLog
            ? '/gatekeeper/0:1/0/0/InOutResult:1/0:0'
            : '/gatekeeper/0:1/0/0/InOutHistoryUserUnregistered:1/0:0';
    }
  }

  /**
   * APIのエラーメッセージダイアログを表示する
   * @param {object} response レスポンスデータ
   * */
  showErrorMessageDialog = response => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.otherErrorDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = extractErrorMessage(response);
    state.informationModal.buttonText = messageUtility.getMessage('I-000-017');
    this.setState(state);
  };

  /**
   * ダイアログ周りのステータスを初期化する
   * @param {object} state: ステート情報
   * */
  closeDialog = () => {
    const state = _.cloneDeep(this.state);
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;
    state.informationModal.multilineText = false;
    this.setState(state);
  };

  renderItem(item) {
    return (
      <tr className='table__item'>
        <td className='gate-list-value-table__name'>
          <p>
            {item.name_sei} {item.name_mei}
          </p>
        </td>
        <td className='gate-list-value-table__name'>
          <p>{item.target_date}</p>
        </td>
        <td className='gate-list-value-table__name line-break'>
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[100, 0]}
            placement='bottom'
            followCursor={true}
            html={
              <div className={Styles.toopTip}>{item.ccus_error_message}</div>
            }
          >
            <p>{item.ccus_error_message}</p>
          </Tippy>
        </td>
        <td className='gate-list-value-table__name'>
          <p>{item.ccus_error_code}</p>
        </td>
        <td className='gate-list-value-table__name'>
          {this.isConfirmAvailable(item) && (
            <button
              className='btn--contained'
              onClick={() => {
                this.confirmError(item);
              }}
            >
              {data.buttonTitle.confirm}
            </button>
          )}
        </td>
      </tr>
    );
  }

  renderContent() {
    return (
      <div className='scroll' id={this.targetId}>
        <table className='table'>
          <thead className='table__header'>
            <tr className='table__label'>
              {data.tableTitles.map((title, index) => (
                <th
                  className='value-table value-table--table__label'
                  key={index}
                >
                  <div className='value-table__label'>{title}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='table__body'>
            {this.state.transmissionErrorResults.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  {this.renderItem(item)}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        <InfinityScrollLoad
          targetId={this.targetId}
          callback={notifyEnd => {
            this.loadErrorResults(notifyEnd);
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Information
          rootClassName={Styles.transmissionErrorResultDialog}
          title={messageUtility.getMessage('I-002-008-03')}
          message={this.renderContent()}
          buttonText={data.buttonTitle.close}
          visible={this.props.isOpened}
          onClose={this.props.onClose}
        />
        <Information
          title={this.state.informationModal.title}
          message={this.state.informationModal.message}
          buttonText={this.state.informationModal.buttonText}
          multilineText={this.state.informationModal.multilineText}
          visible={
            this.state.dialogStatus === DIALOG_STATUS.otherErrorDialogEnabled.id
          }
          onClose={() => this.closeDialog()}
        />
      </React.Fragment>
    );
  }
}

TransmissionErrorResult.propTypes = {
  fieldId: PropTypes.number,
  checkInOutLogTransmissionHistoryId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
};

// 定数
const data = {
  tableTitles: ['氏名', '日付', 'エラー内容', 'CCUSエラーコード', ''],
  buttonTitle: {
    close: '閉じる',
    confirm: '確認',
  },
};

export default TransmissionErrorResult;



// WEBPACK FOOTER //
// ./src/components/modals/TransmissionErrorResult.jsx